import {
  DatePicker,
  Modal,
  Upload,
  Image,
  message,
  Spin,
  
  Table,
  Checkbox,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Info, PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import {
  getEmployeeById,
  createEmployeeMethod,
  deleteEmployeeMethod,
  getAllAllowances,
  getAllDesignations,
  getAllEmployeesMethod,
  getAllShiftsMethod,
} from "../../service/ApiServices";
import moment from "moment";
import Swal from "sweetalert2";
import Select from "react-select";
import EmployeeResignModal from "../../core/modals/hrm/employeeResign";
import { getSearchEmployees } from "../../service/employeeService";
import BulkUploadModal from "../../core/modals/hrm/bulkupload-employee";
import jsPDF from "jspdf";
import ExcelJS from "exceljs";
import okilogo from "../../assets/logo.png";
import dayjs from "dayjs";
import { Select as AntSelect, notification } from "antd";
import {getResignationsByEmployeeId} from '../../service/employeeResignService';

const { RangePicker } = DatePicker;
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const employeeCategoryOptions = [
  { value: "Full Time", label: "Full Time" },
  {
    value: "Part Time",
    label: "Part Time",
  },
  { value: "Daily Basics", label: "Daily Basics" },
];

const titleOptions = [
  { value: "Mr", label: "Mr." },
  { value: "Mrs", label: "Mrs." },
  {
    value: "Miss",
    label: "Miss.",
  },
  { value: "Ms", label: "Ms." },
  { value: "Rev", label: "Rev." },
  { value: "Dr", label: "Dr." },
];

const gender = [
  { value: "", label: "Choose" },
  { value: "male", label: "Male" },
  {
    value: "female",
    label: "Female",
  },
  { value: "other", label: "Other" },
];

const payFrequencies = [
  { value: "", label: "Choose" },
  { value: "weekly", label: "Weekly" },
  {
    value: "biweekly",
    label: "Biweekly",
  },
  { value: "semimonthly", label: "Semi-Monthly" },
  { value: "monthly", label: "Monthly" },
  {
    value: "annually",
    label: "Annually",
  },
];

const statusOptions = [
  { value: "Active", label: "Active" },
  {
    value: "Inactive",
    label: "Clearance Pending",
  },
  { value: "Inactive", label: "Payment Pending" },
  { value: "Inactive", label: "Resigned" },
];

const EmployeesGrid = () => {
  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  // const roleName = userData?.data.role.roleName;
  const username = userData?.data.name;
  //const formDataToSend = new FormData();
  const [fileLists, setFileLists] = useState([]);
  //const [column, setColunm] = useState(c)
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [reason, setReason] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [uploadedPic, setUploadedPic] = useState("");
  const [uploading, setUploading] = useState(false);
  const [designations, setDesignations] = useState([]);

  const [allowances, setAllowances] = useState([]);
  // const [search, setSearch] = useState("")
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isResign, setIsResign] = useState(false);
  const [record, setRecord] = useState("");
  const [empRecord, setEmpRecord] = useState({});
  const [recordId, setRecordId] = useState(null);

  const [shifts, setShifts] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    data: [],
    total: 0,
    current_page: 1,
    per_page: 10,
  });
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    full_name: "",
    nic: "",
    center: "",
    employeeCategory: "",
    title: "",
    email: "",
    contactNumber: "",
    dateOfBirth: null,
    joiningDate: null,
    departmentId: "",
    designationId: "",
    epfNumber: "",
    basicSalary: "",
    employeeId: "",
    branch: "",
    dateOfTermination: "",
    nationality: "",
    shift: "",
    gender: "",
    payFrequency: "",
    allowances: [],
    payeeTaxApplicable: false,
    overtimeEligibility: false,
    emergencyNo1: "",
    emergencyNo2: "",
    address: "",
    city: "",
    province: "",
    accountHolderName: "",
    accountNumber: "",
    bankName: "",
    branchLocation: "",
    taxPayerId: "",
  });
  const [searchEpfNumber, setSearchEpf] = useState("");
  const [searchName, setSearchName] = useState("");
  const [resignStatus, setResignStatus] = useState(null);
  const [resignData, setResignData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [errors, setErrors] = useState({});
  const formRef = useRef({});
  useEffect(() => {
    const initialCalls = async () => {
      // console.log("Starting initial calls");
      getAllShiftsMethod({ setShiftData: setShifts });
      let data = await getAllAllowances({ search: "", setLoading: setLoading });
      setAllowances(
        data.map((item) => ({
          label: item.name,
          value: item._id,
        }))
      );
      getAllDesignations({
        search: "",
        setData: setDesignations,
        setLoading: setLoading2,
      });

      // console.log("Calling initial searchEmployees");
      // Call searchEmployees with default parameters to load the initial data
      await searchEmployees(1, 10);

      // Log the state after a brief delay to ensure it's been updated
      setTimeout(() => {
        // console.log("Delayed check of employeeData:", employeeData);
      }, 1000);
    };
    initialCalls();
  }, []);

  const searchEmployees = async (pageNum = 1, pageSize = 10) => {
    // console.log("Searching employees with params:", {
    //   status: resignStatus,
    //   epf_number: searchEpfNumber,
    //   name: searchName,
    //   startDate,
    //   endDate,
    //   page: pageNum,
    //   limit: pageSize,
    // });
    
    const records = await getSearchEmployees({
      setLoading: setLoading3,
      status: resignStatus,
      epf_number: searchEpfNumber,
      name: searchName,
      startDate,
      endDate,
      page: pageNum,
      limit: pageSize,
    });

    // console.log("API Response:", records);

    if (records) {
      setEmployeeData(records); // Store the full response object, not just data array
      // console.log("Updated employeeData state:", records);
    } else {
      setEmployeeData({ data: [], total: 0, current_page: 1, per_page: 10 }); // Ensure fallback to an empty array
      // console.log("No records found, setting empty state");
    }
  };
  const handleSearch = () => {
    // console.log("Search button clicked with parameters:", {
    //   resignStatus,
    //   searchEpfNumber,
    //   searchName,
    //   startDate,
    //   endDate,
    // });
    // Reset to first page and call searchEmployees
    searchEmployees(1, 10);
  };

  const onChange = (dates, dateStrings) => {
    if (dateStrings && dateStrings[0] && dateStrings[1]) {
      // Store the dateStrings directly as string values in "YYYY-MM-DD" format
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };
  const handleResignStatusChange = (status) => {
    setResignStatus(status);

    // If status is "Active", clear the date range
    if (status === "Active") {
      setStartDate(null);
      setEndDate(null);
    }
  };
  const handleResign = (record) => {
    setIsResign(true);
    setEmpRecord(record);
    setRecordId(record._id);
  };
  /////PDf Export

  const handlePdfExport = () => {
    const date = dayjs().format("YYYY-MM-DD");
    const img = okilogo;
    const employees =
      employeeData && employeeData.data ? employeeData.data : [];

    // Filter out unwanted columns
    const filteredData = employees.map((emp) => ({
      name: `${emp.full_name}`,
      number: emp.epf_number,
      joined_date: emp.joining_date
        ? new Date(emp.joining_date).toISOString().split("T")[0]
        : "N/A",
      email: emp.email || "N/A",
      phone: emp.contact_number || "N/A",
      designation: emp.designation ? emp.designation.designationName : "N/A",
    }));

    const doc = new jsPDF();

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.text("OKI International ", 15, 13);

    doc.setFontSize(13);
    doc.setTextColor(138, 132, 125);
    doc.text(`Employees List`, 15, 23);
    doc.text(`Date: ${date}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);
    doc.autoTable({
      head: [
        [
          "Employee Name",
          "Employee Number",
          "Joined Date",
          "Email",
          "Phone",
          "Designation",
        ],
      ],
      body: filteredData.map((data) => [
        data["name"],
        data["number"],
        data["joined_date"],
        data["email"],
        data["phone"],
        data["designation"],
      ]),
      startY: 35,
      theme: "striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });

    doc.save("employees_list.pdf");
  };

  ////Excel Export
  const handleExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees Report");
    const employees =
      employeeData && employeeData.data ? employeeData.data : [];

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    worksheet.columns = [
      { header: "Emp Name", key: "name", width: 20 },
      { header: "Emp Id", key: "number", width: 20 },
      { header: "Joined Date", key: "joined_date", width: 15 },
      { header: "Email", key: "email", width: 30 },
      { header: "Contact Number", key: "phone", width: 20 },
      { header: "Designation", key: "designation", width: 25 },
    ];

    employees.forEach((emp) => {
      worksheet.addRow({
        name: `${emp.full_name}`,
        number: emp.epf_number,
        joined_date: emp.joining_date
          ? new Date(emp.joining_date).toISOString().split("T")[0]
          : "N/A",
        email: emp.email || "N/A",
        phone: emp.contact_number || "N/A",
        designation: emp.designation ? emp.designation.designationName : "N/A",
      });
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Employees_Report.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const columns = [
    {
      title: "Profile Pic",
      dataIndex: "profile_picture",
      key: "profile_picture",
      render: (profile_picture) => (
        <Image
          src={profile_picture}
          alt="Profile Picture"
          width={75}
          height={75}
          style={{
            borderRadius: "50%",
            objectFit: "cover",
          }}
          preview={{
            zIndex: 10000,
            visible: previewOpen,
            src: previewImage,
            onVisibleChange: (visible) => setPreviewOpen(visible),
          }}
          onClick={() => {
            setPreviewImage(profile_picture);
            setPreviewOpen(true);
          }}
        />
      ),
      width: "110px",
    },
    {
      title: "NIC",
      key: "nic",
      render: (text, record) => (record.nic ? record.nic : "N/A "),
    },
    {
      title: "Full Name",
      key: "Full Name",
      dataIndex: "full_name",
    },
    {
      title: "EPF No",
      dataIndex: "epf_number",
      key: "employee_id",
    },
    {
      title: "Joined Date",
      dataIndex: "joining_date",
      key: "joining_date",
      render: (text) =>
        text ? new Date(text).toISOString().split("T")[0] : "N/A",
    },
    {
      title: "Designation",
      dataIndex: ["designation", "designationName"],
      key: "designation.designationName",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          className={`badge ${
            status === "Active" ? "badge-linesuccess" : "badge-linedanger"
          }`}
          style={{ width: 80, padding: 6 }}
        >
          <Link to="#" style={{ cursor: "default", fontSize: 14 }}>
            {status}
          </Link>
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <Link
            className="me-2 p-2"
            onClick={() => {
              setDataFunc(record, false);
            }}
          >
            <i data-feather="download" className="feather-eye"></i>
          </Link>
          {record.status == "Active" &&(
          <Link
            className="me-2 p-2"
            onClick={() => {
              setDataFunc(record, true);
            }}
          >
            <i data-feather="download" className="feather-edit"></i>
          </Link>
          )}
          {record.status == "Active" && (
            <Link
              className="me-2 p-2"
              title="Resign"
              onClick={() => handleResign(record)}
            >
              <i data-feather="download" className="feather-user-minus"></i>
            </Link>
          ) }
          {/* {roleName === "Admin" && (
            <Popconfirm
              title="Delete the Employee"
              description="Are you sure to disable this Employee?"
              onConfirm={() => {
                setIsModalOpen2(true);
                setRecord(record);
              }}
              onCancel={() => {
                // console.log("c");
              }}
              okText="Yes"
              cancelText="No"
            >
              <Link className="confirm-text p-2">
                <i data-feather="x-circle" className="feather-x-circle"></i>
              </Link>
            </Popconfirm>
          )} */}
        </div>
      ),
    },
  ];

  const setDataFunc = async (record, isEdit) => {
    const employeeId = record._id;

    //console.log(employeeId )
    await getEmployeeById(employeeId);
    const records = await getResignationsByEmployeeId (employeeId)
    
    if (records) {
      setResignData(records.data);
    } else {
      setResignData([]);
    }
    // console.log(record?.profile_image_url, "Profile Path");

    setUploadedPic(record?.profile_image_url);
    setFormData({
      accountNumber: record?.account_number || "",
      branch: record?.branch || "",
      title: record?.title || "",
      full_name:
        record?.full_name ||
        `${record?.first_name || ""} ${record?.last_name || ""}`,
      email: record?.email || "",
      nic: record?.nic || "",
      contactNumber: record?.contact_number || "",
      dateOfBirth: record?.date_of_birth
        ? record.date_of_birth.split("T")[0]
        : null,
      joiningDate: record?.joining_date.split("T")[0] || null,
      departmentId: record?.department_id || "",
      designationId: record?.designation_id || "",
      epfNumber: record?.epf_number || "",
      basicSalary: record?.basic_salary || "",
      workLocation: record?.work_location || "",
      dateOfTermination: record?.date_of_termination
        ? record.date_of_termination.split("T")[0]
        : "",
      nationality: record?.nationality || "",
      shift: record?.shift || "",
      bloodGroup: record?.blood_group || "",
      gender: record?.gender || "",
      center: record?.center || "",
      employeeType: record?.employee_type || "",
      contractPeriod: record?.contract_period
        ? record.contract_period.split(",")
        : "",
      employeeCategory: record?.employee_category || "",
      jobGrade: record?.job_grade || "",
      payFrequency: record?.pay_frequency || "",
      allowances:
        record?.allowances.map((item1) => {
          const matchItem = allowances.filter(
            (item2) => item1.name === item2.value
          );
          return {
            id: {
              value: item1.name,
              label: matchItem[0].label,
            },
            amount: item1.amount,
          };
        }) || [],
      payeeTaxApplicable: record?.payee_tax_applicable || false,
      overtimeEligibility: record?.overtime_eligibility || false,
      emergencyNo1: record?.emergency_no_1 || "",
      emergencyNo2: record?.emergency_no_2 || "",
      address: record?.address || "",
      city: record?.city || "",
      province: record?.province || "",
      employeeId: record._id,
      bankName: record?.bank || "",
      accountHolderName: record?.account_holder || "",
      branchLocation: record?.branchLocation || "",
      lastEditedAt: record?.lastEditedAt || "",
      lastEditedBy: record?.lastEditedBy || "",
    });
    if (isEdit) {
      setIsEdit(true);
    } else {
      if (
        record &&
        Array.isArray(record.skills_doc_urls) &&
        record.skills_doc_urls.length > 0
      ) {
        setFileLists((prev) => ({
          ...prev,
          skills_and_competencies: [...record.skills_doc_urls],
        }));
      }
      if (
        record &&
        Array.isArray(record.qualifications_doc_urls) &&
        record.qualifications_doc_urls.length > 0
      ) {
        setFileLists((prev) => ({
          ...prev,
          educational_qualifications: [...record.qualifications_doc_urls],
        }));
      }
      if (
        record &&
        Array.isArray(record.certifications_doc_urls) &&
        record.certifications_doc_urls.length > 0
      ) {
        setFileLists((prev) => ({
          ...prev,
          professional_certifications: [...record.certifications_doc_urls],
        }));
      }
      setIsView(true);
    }
    setIsModalOpen(true);
    setUploadedPic(record.profile_picture);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setErrors({});
    handleReset();
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value,
    });
  };

  const handleCustomRequest = async ({ file, onSuccess, onError }) => {
    setUploading(true);
    try {
      // Store the file for later use in form submission
      setFileList([
        {
          originFileObj: file,
          name: file.name,
          status: "done",
        },
      ]);
      onSuccess(true);
      message.success(`${file.name} ready for upload`);
    } catch (error) {
      onError(error);
      message.error(`${file.name} preparation failed`);
    } finally {
      setUploading(false);
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleDateChange = (date, dateString, field) => {
    setFormData((prev) => ({ ...prev, [field]: dateString }));
  };

  const validateForm = (formData) => {
    let newErrors = {};

    const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?\d{10}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validations
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.full_name) newErrors.full_name = "Full Name is required";
    if (!formData.nic) newErrors.nic = "NIC is required";
    if (formData.email && !emailRegex.test(formData.email.trim())) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.contactNumber)
      newErrors.contactNumber = "Phone Number is required";
    else if (!phoneRegex.test(formData.contactNumber))
      newErrors.contactNumber = "Invalid phone number format";
    if (!formData.dateOfBirth)
      newErrors.dateOfBirth = "Date of Birth is required";
    if (!formData.joiningDate)
      newErrors.joiningDate = "Joining Date is required";
    if (!formData.shift) newErrors.shift = "Shift is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.employeeCategory)
      newErrors.employeeCategory = "Employee Category is required";
    if (!formData.designationId)
      newErrors.designationId = "Designation is required";
    if (!formData.accountHolderName)
      newErrors.accountHolderName = "Account Holder name is required";
    if (!formData.accountNumber)
      newErrors.accountNumber = "Account Number is required";
    if (!formData.bankName) newErrors.bankName = "Bank Name is required";
    if (!formData.branchLocation)
      newErrors.branchLocation = "Branch Location is required";
    if (!formData.emergencyNo1)
      newErrors.emergencyNo1 = "emergency No1 is required";
    if (formData.employeeCategory === "Full Time") {
      if (!formData.basicSalary) {
        newErrors.basicSalary =
          "Basic Salary is required for Full Time employees";
      }
    }

    // Set all errors
    setErrors(newErrors);
    console.log("Validation errors:", newErrors);

    // Focus on First Error Field
    const firstErrorKey = Object.keys(newErrors)[0];
    if (firstErrorKey && formRef.current?.[firstErrorKey]) {
      formRef.current[firstErrorKey].focus();
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    // console.log("Form Data", formData);

    const isValid = validateForm(formData);
    // console.log(isValid);

    if (!isValid) {
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();

    // Add all form fields to FormData
    Object.keys(formData).forEach((key) => {
      if (key === "allowances") {
        formDataToSend.append(
          key,
          JSON.stringify(
            formData[key].map((item) => ({
              name: item.id.value || item.id,
              amount: item.amount,
            }))
          )
        );
      } else if (formData[key] !== null && formData[key] !== undefined) {
        formDataToSend.append(key, formData[key]);
      }
    });

    // Add profile picture if exists
    if (fileList.length > 0 && fileList[0].originFileObj) {
      formDataToSend.append("profilePicture", fileList[0].originFileObj);
    }
    if (username) {
      formDataToSend.append("userName", username);
    }

    // Add other document files if they exist
    Object.keys(fileLists).forEach((key) => {
      fileLists[key].forEach((file) => {
        if (file.originFileObj) {
          formDataToSend.append(key, file.originFileObj);
        }
      });
    });

    createEmployeeMethod({ formdata: formDataToSend })
      .then((value) => {
        if (value.data.status === "success") {
          showSuccess(value.data.message);
        } else {
          showSuccess("Employee updated successfully");
        }
        setIsModalOpen(false);
        handleReset();
        searchEmployees();
      })
      .catch((reason1) => {
        console.log("reason1", reason1);
        api["error"]({
          message: "Error",
          description: reason1?.response?.data?.message || "Something went wrong, Please contact system admin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReset = () => {
    setFormData({
      bankName: "",
      full_name: "",
      nic: "",
      center: "",
      branch: "",
      employeeCategory: "",
      title: "",
      email: "",
      contactNumber: "",
      dateOfBirth: null,
      joiningDate: null,
      departmentId: "",
      designationId: "",
      epfNumber: "",
      basicSalary: "",
      employeeId: "",
      workLocation: "",
      dateOfTermination: "",
      nationality: "",
      shift: "",
      bloodGroup: "",
      gender: "",
      employeeType: "",
      contractPeropd: "",
      jobGrade: "",
      payFrequency: "",
      allowances: [],
      payeeTaxApplicable: false,
      overtimeEligibility: false,
      emergencyNo1: "",
      emergencyNo2: "",
      address: "",
      city: "",
      province: "",
      password: "",
      conformPassword: "",
      accountNumber: "",
      accountHolderName: "",
      branchLocation: "",
    });
    setFileList([]);
    setPreviewImage("");
    setUploadedPic("");
    setIsEdit(false);
    setIsView(false);
    setFileLists({});
    //window.location.reload();
  };

  const showSuccess = (msg) => {
    api["success"]({
      message: "Success",
      description: msg,
      duration: 2,
    });
  };

  const showWarning = (str) => {
    return Swal.fire({
      title: "Error",
      text: str,
      icon: "error",
    });
  };

  /* const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };*/

  const handleTableChange = (pagination) => {
    // console.log("Table pagination changed:", pagination);

    if (
      resignStatus === null &&
      searchName === "" &&
      searchEpfNumber === "" &&
      startDate === null &&
      endDate === null
    ) {
      // console.log("No search filters active, using getAllEmployeesMethod");
      getAllEmployeesMethod({
        setEmployeeData,
        setLoading: setLoading3,
        params: { page: pagination.current, limit: pagination.pageSize },
        search: "",
      });
    } else {
      // If there are search filters active, use searchEmployees with pagination
      console.log(
        "Search filters active, using searchEmployees with pagination"
      );
      searchEmployees(pagination.current, pagination.pageSize);
    }
  };

  const historyColumn = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => {
        const formattedDate = text
          ? new Date(text).toISOString().split("T")[0]
          : "N/A";
        return formattedDate;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        return text && text.trim() !== "" ? text : "-";
      },
    },
  ];

  return (
    <div className="page-wrapper">
      {contextHolder}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employees</h4>
              <h6>Manage your employees</h6>
            </div>
          </div>
          <div className="wordset">
            <ul>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="pdf"
                  onClick={handlePdfExport}
                >
                  <img src="assets/img/icons/pdf.svg" alt="pdf" />
                </a>
              </li>
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="excel"
                  onClick={handleExcelExport}
                >
                  <img src="assets/img/icons/excel.svg" alt="excel" />
                </a>
              </li>
            </ul>
          </div>
          <div className="page-btn">
            <a
              className="btn btn-added"
              onClick={() => setIsBulkUploadModalOpen(true)}
            >
              Bulk upload
            </a>
          </div>
          <div className="page-btn">
            {/* {hasJobRightWithAdd && ( */}
            <a className="btn btn-added" onClick={() => setIsModalOpen(true)}>
              <PlusCircle className="me-2" />
              Add New Employee
            </a>
            {/* )} */}
          </div>
        </div>

        <div className="card table-list-card">
          <div
            className="card-body"
            style={{ maxWidth: "100%", marginRight: "20px" }}
          >
            <div
              className="container mt-3 "
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              {" "}
              {/* Added p-0 and maxWidth */}
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                {" "}
                {/* Added justify-content-start */}
                <div className="col-12 col-md-3  text-start">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    value={searchName}
                    className="form-control"
                    onChange={(e) => {
                      setSearchName(e.target.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">EPF No</label>
                  <input
                    type="text"
                    value={searchEpfNumber}
                    className="form-control"
                    onChange={(e) => {
                      setSearchEpf(e.target.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label className="form-label">Status</label>

                  <AntSelect
                    value={resignStatus}
                    options={statusOptions}
                    className="select"
                    placeholder="Select Status"
                    onChange={handleResignStatusChange}
                    allowClear
                    style={{ width: "100%", height: "38px" }}
                  />
                </div>
              </div>
            </div>
            <div
              className="container mt-0 "
              style={{
                maxWidth: "100%",
                marginLeft: "20px",
                marginRight: "40px",
              }}
            >
              {" "}
              {/* Added p-0 and maxWidth */}
              <div className="row d-flex flex-wrap align-items-start justify-content-between">
                {" "}
                {/* Added justify-content-start */}
                <div className="col-12 col-md-3 mb-3 text-start">
                  <label className="form-label">Date</label>
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={onChange}
                    disabled={
                      resignStatus === null || resignStatus === "Active"
                    }
                    // Convert startDate and endDate to dayjs objects if they're not null
                    value={[
                      startDate ? dayjs(startDate) : null,
                      endDate ? dayjs(endDate) : null,
                    ]}
                    style={{ width: "100%" }}
                    allowClear
                  />
                </div>
                <div className="col-12 col-md-2 mb-3 text-start">
                  <label
                    className="form-label"
                    style={{ visibility: "hidden" }}
                  >
                    Hidden Label
                  </label>
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-submit"
                      onClick={handleSearch}
                      style={{ height: "38px", width: "55%" }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Ensure employeeData is always an array */}
        <Table
          columns={columns}
          dataSource={
            employeeData && Array.isArray(employeeData.data)
              ? employeeData.data
              : []
          }
          rowKey="_id"
          size={"small"}
          loading={loading3}
          onChange={handleTableChange}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
            total: employeeData?.total || 0,
            current: employeeData?.current_page || employeeData?.page || 1,
            pageSize: employeeData?.per_page || employeeData?.limit || 10,
            showTotal: (total, range) =>
              `Showing ${range[0]}-${range[1]} of ${total} employees`,
          }}
        />
      </div>
      <Modal
        zIndex={1200}
        open={isModalOpen}
        onOk={handleOk}
        width="75vw"
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <form>
          <div className="card">
            <div className="card-body">
              <div className="new-employee-field">
                <div className="modal-header custom-modal-header">
                  <div className="page-title">
                    <h4>
                      {isEdit ? "Edit" : isView ? "View" : "Create"} Employee
                    </h4>
                    {!isView && (
                      <p className="mb-0">
                        Fill in the required fields to create an Employee
                      </p>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    marginBottom: "30px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    {(isEdit || isView) && (
                      <label
                        className="form-label"
                        style={{ display: "block", marginBottom: "10px" }}
                      >
                        Uploaded Profile Picture
                      </label>
                    )}
                    {(isEdit || isView) && (
                      <Image
                        src={uploadedPic}
                        alt="Profile Picture"
                        width={120}
                        height={120}
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%",
                          border: "2px solid #ddd",
                          padding: "5px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        }}
                        preview={{
                          zIndex: 10000,
                          visible: previewOpen,
                          src: previewImage,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                        }}
                        onClick={() => {
                          setPreviewImage(uploadedPic);
                          setPreviewOpen(true);
                        }}
                      />
                    )}
                  </div>
                </div>
                {/*<div>
                      {
                          isEdit && <Image
                              src={uploadedPic}
                              alt="Profile Picture"
                              width={100}
                              height={100}
                              style={{

                                objectFit: 'cover',
                              }}
                              preview={{
                                zIndex: 10000,
                                visible: previewOpen,
                                src: previewImage,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                              }}
                              onClick={() => {
                                setPreviewImage(uploadedPic);
                                setPreviewOpen(true);
                              }}
                          />
                      }
                    </div> */}
                <div className="profile-pic-upload">
                  {!isView && (
                    <div className="input-blocks mb-0">
                      <ImgCrop>
                        <Upload
                          listType="picture-circle"
                          fileList={fileList}
                          onPreview={handlePreview}
                          onChange={handleChange}
                          customRequest={handleCustomRequest}
                          disabled={uploading}
                        >
                          {fileList.length >= 1 ? null : uploadButton}
                        </Upload>
                      </ImgCrop>

                      {previewImage && (
                        <Image
                          wrapperStyle={{ display: "none" }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                      <label className="form-label">
                        {isEdit && "Upload New"}Profile Picture
                      </label>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Employee Information
                    </h6>
                  </div>
                  <div className="col-lg-4 col-md-2">
                    <div className="mb-3 ">
                      <label className="form-label">Title</label>
                      <Select
                        hasFeedback
                        validateStatus="error"
                        value={
                          formData.title === ""
                            ? null // Show placeholder if employeeCategory is empty
                            : titleOptions.find((option) =>
                                formData.title.includes(option.value)
                              )
                        }
                        options={titleOptions}
                        className={`select ${errors.title ? "is-invalid" : ""}`}
                        placeholder="Select Title" // Optional placeholder text
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "title")
                        }
                        isDisabled={isView}
                        status={errors.title ? "error" : ""}
                      />
                      {errors.title && (
                        <div className="text-danger">{errors.title}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.full_name ? "is-invalid" : ""
                        }`}
                        value={formData.full_name}
                        onChange={(e) => handleInputChange(e, "full_name")}
                        disabled={isView}
                        ref={(el) => (formRef.current.full_name = el)}
                      />
                      {errors.full_name && (
                        <div className="text-danger">{errors.full_name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">NIC</label>
                      <input
                        required
                        type="text"
                        className={`form-control ${
                          errors.nic ? "is-invalid" : ""
                        }`}
                        value={formData.nic}
                        onChange={(e) => handleInputChange(e, "nic")}
                        disabled={isView}
                        ref={(el) => (formRef.current.nic = el)}
                      />
                      {errors.nic && (
                        <div className="text-danger">{errors.nic}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Email <Tag color="orange">Optional</Tag>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={formData.email}
                        onChange={(e) => handleInputChange(e, "email")}
                        disabled={isView}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.contactNumber ? "is-invalid" : ""
                        }`}
                        value={formData.contactNumber}
                        onChange={(e) => handleInputChange(e, "contactNumber")}
                        disabled={isView}
                        ref={(el) => (formRef.current.contactNumber = el)}
                      />
                      {errors.contactNumber && (
                        <div className="text-danger">
                          {errors.contactNumber}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Date of Birth</label>
                      <div className="input-groupicon calender-input">
                        <DatePicker
                          value={
                            formData.dateOfBirth
                              ? moment(formData.dateOfBirth, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date, dateString) =>
                            handleDateChange(date, dateString, "dateOfBirth")
                          }
                          className={`form-control ${
                            errors.dateOfBirth ? "is-invalid" : ""
                          }`}
                          placeholder="Choose Date"
                          disabled={isView}
                          ref={(el) => (formRef.current.dateOfBirth = el)}
                        />
                        {errors.dateOfBirth && (
                          <div className="text-danger">
                            {errors.dateOfBirth}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Joining Date</label>
                      <div className="input-groupicon calender-input">
                        <DatePicker
                          value={
                            formData.joiningDate
                              ? moment(formData.joiningDate, "YYYY-MM-DD")
                              : null
                          }
                          onChange={(date, dateString) =>
                            handleDateChange(date, dateString, "joiningDate")
                          }
                          className={`form-control ${
                            errors.joiningDate ? "is-invalid" : ""
                          }`}
                          placeholder="Choose Date"
                          disabled={isView}
                          ref={(el) => (formRef.current.joiningDate = el)}
                        />
                        {errors.joiningDate && (
                          <div className="text-danger">
                            {errors.joiningDate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Select Shift</label>
                      <Select
                        isDisabled={isView}
                        size="large"
                        showSearch
                        className={`select ${errors.shift ? "is-invalid" : ""}`}
                        placeholder="Choose"
                        value={shifts.find(
                          (option) => option.value === formData.shift
                        )}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "shift")
                        }
                        options={shifts}
                        style={{ width: "100%" }}
                      />
                      {errors.shift && (
                        <div className="text-danger">{errors.shift}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Gender</label>
                      <Select
                        isDisabled={isView}
                        name="gender"
                        value={gender.find(
                          (option) => option.value === formData.gender
                        )}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "gender")
                        }
                        className={`select ${
                          errors.gender ? "is-invalid" : ""
                        }`}
                        options={gender}
                        placeholder="Choose"
                      />
                      {errors.gender && (
                        <div className="text-danger">{errors.gender}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Employee Category</label>
                      <Select
                        value={
                          formData.employeeCategory === ""
                            ? null // Show placeholder if employeeCategory is empty
                            : employeeCategoryOptions.find(
                                (option) =>
                                  option.value === formData.employeeCategory
                              )
                        }
                        options={employeeCategoryOptions}
                        className={`select ${
                          errors.employeeCategory ? "is-invalid" : ""
                        }`}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "employeeCategory")
                        }
                        placeholder="Select Employee Category"
                        isDisabled={isView}
                      />
                      {errors.employeeCategory && (
                        <div className="text-danger">
                          {errors.employeeCategory}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Designation</label>
                      <div className="input-blocks">
                        {loading2 ? (
                          <Spin size="small" />
                        ) : (
                          <select
                            disabled={isView}
                            className={`form-select ${
                              errors.designationId ? "is-invalid" : ""
                            }`}
                            value={formData.designationId}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                designationId: e.target.value,
                              }))
                            }
                          >
                            <option value={"pending"}>Choose</option>
                            {designations &&
                              designations.map((des, index) => (
                                <option key={index} value={des._id}>
                                  {des.designationName}
                                </option>
                              ))}
                          </select>
                        )}
                        {errors.designationId && (
                          <div className="text-danger">
                            {errors.designationId}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Pay Frequency <Tag color="orange">Optional</Tag>
                      </label>
                      <Select
                        isDisabled={isView}
                        name="gender"
                        value={payFrequencies.find(
                          (option) => option.value === formData.payFrequency
                        )}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "payFrequency")
                        }
                        className="select"
                        options={payFrequencies}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                </div>
                {formData.employeeCategory === "Full Time" && (
                  <div className="row" style={{ marginTop: "10PX" }}>
                    <div className="card-title-head">
                      <h6>
                        <span>
                          <Info className="feather-edit" />
                        </span>
                        Compensation and Benefits
                      </h6>
                    </div>
                    <div className="col-lg-4 col-md-4">
                      <div className="mb-3">
                        <label className="form-label">EPF Number</label>
                        <input
                          disabled={isView}
                          type="text"
                          className={`form-control ${
                            errors.epfNumber ? "is-invalid" : ""
                          }`}
                          value={formData.epfNumber}
                          onChange={(e) => handleInputChange(e, "epfNumber")}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-4">
                      <div className="mb-3">
                        <label className="form-label">Basic Salary</label>
                        <input
                          disabled={isView}
                          type="number"
                          className={`form-control ${
                            errors.basicSalary ? "is-invalid" : ""
                          }`}
                          value={formData.basicSalary}
                          onChange={(e) => {
                            if (parseFloat(e.target.value) <= 0) {
                              showWarning("Can't be negative or zero");
                              return;
                            }
                            handleInputChange(e, "basicSalary");
                          }}
                        />
                        {errors.basicSalary && (
                          <div className="text-danger">
                            {errors.basicSalary}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <Checkbox
                          disabled={isView}
                          checked={formData.payeeTaxApplicable}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              payeeTaxApplicable: e.target.checked,
                            }));
                          }}
                        >
                          <p style={{ color: "black" }}>Payee Tax applicable</p>
                        </Checkbox>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-3">
                        <Checkbox
                          disabled={isView}
                          checked={formData.overtimeEligibility}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              overtimeEligibility: e.target.checked,
                            }));
                          }}
                        >
                          <p style={{ color: "black" }}>Overtime Eligibility</p>
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                )}
                <div className="row" style={{ marginTop: "10PX" }}>
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Bank Information
                    </h6>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Account Holder Name</label>
                      <input
                        disabled={isView}
                        type="text"
                        className={`form-control ${
                          errors.accountHolderName ? "is-invalid" : ""
                        }`}
                        value={formData.accountHolderName}
                        onChange={(e) =>
                          handleInputChange(e, "accountHolderName")
                        }
                        ref={(el) => (formRef.current.accountHolderName = el)}
                      />
                      {errors.accountHolderName && (
                        <div className="text-danger">
                          {errors.accountHolderName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Account Number</label>
                      <input
                        disabled={isView}
                        type="text"
                        className={`form-control ${
                          errors.accountNumber ? "is-invalid" : ""
                        }`}
                        value={formData.accountNumber}
                        onChange={(e) => handleInputChange(e, "accountNumber")}
                        ref={(el) => (formRef.current.accountNumber = el)}
                      />
                      {errors.accountNumber && (
                        <div className="text-danger">
                          {errors.accountNumber}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Bank Name</label>
                      <input
                        disabled={isView}
                        type="text"
                        className={`form-control ${
                          errors.bankName ? "is-invalid" : ""
                        }`}
                        value={formData.bankName}
                        onChange={(e) => handleInputChange(e, "bankName")}
                        ref={(el) => (formRef.current.bankName = el)}
                      />
                      {errors.bankName && (
                        <div className="text-danger">{errors.bankName}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Branch Location</label>
                      <input
                        disabled={isView}
                        type="text"
                        className={`form-control ${
                          errors.branchLocation ? "is-invalid" : ""
                        }`}
                        value={formData.branchLocation}
                        onChange={(e) => handleInputChange(e, "branchLocation")}
                        ref={(el) => (formRef.current.branchLocation = el)}
                      />
                      {errors.branchLocation && (
                        <div className="text-danger">
                          {errors.branchLocation}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "10PX" }}>
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Other Information
                    </h6>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Emergency No 1</label>
                      <input
                        disabled={isView}
                        type="text"
                        className={`form-control ${
                          errors.emergencyNo1 ? "is-invalid" : ""
                        }`}
                        value={formData.emergencyNo1}
                        onChange={(e) => handleInputChange(e, "emergencyNo1")}
                        ref={(el) => (formRef.current.emergencyNo1 = el)}
                      />
                      {errors.emergencyNo1 && (
                        <div className="text-danger">{errors.emergencyNo1}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Emergency No 2 <Tag color="orange">Optional</Tag>
                      </label>
                      <input
                        disabled={isView}
                        type="text"
                        className="form-control"
                        value={formData.emergencyNo2}
                        onChange={(e) => handleInputChange(e, "emergencyNo2")}
                      />
                    </div>
                  </div>
                </div>

                {isView && resignData?.length > 0 && (
                  <div className="row" style={{ marginTop: "10px" }}>
                    <div className="card-title-head">
                      <h6>
                        <span>
                          {/* <Layers className="feather-layers" /> */}
                        </span>
                        Employee History
                      </h6>
                    </div>
                    <Table
                      columns={historyColumn} // Use appropriate columns based on isEdit
                      dataSource={resignData}
                      rowKey="value"
                      pagination={false}
                    />
                  </div>
                )}
                {formData && formData.lastEditedAt && (
                  <div className="row">
                    <div className="col-12 mt-3">
                      <div className="alert alert-info" role="alert">
                        <div className="d-flex justify-content-between">
                          <div>
                            <strong>Last Edited:</strong>{" "}
                            {new Date(formData.lastEditedAt).toLocaleString()}
                          </div>
                          <div>
                            <strong>Edited By:</strong>{" "}
                            {formData.lastEditedBy || ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              type="button"
              className="btn btn-cancel"
              onClick={() => {
                handleCancel();
              }}
            >
              Close
            </button>
            {!isView && (
              <div className="">
                {!isEdit && (
                  <button
                    type="button"
                    className="btn btn-reset me-2"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-submit ml-0"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <Spin size="small" /> : "Save"}
                </button>
              </div>
            )}
          </div>
        </form>
      </Modal>

      <Modal
        zIndex={1200}
        open={isModalOpen2}
        onOk={() => {
          setIsModalOpen2(false);
          setReason("");
          setRecord("");
        }}
        width="45vw"
        onCancel={() => {
          setIsModalOpen2(false);
          setReason("");
          setRecord("");
        }}
        footer={null}
        maskClosable={false}
        closable={false}
      >
        <div className="card">
          <div className="card-body">
            <form>
              <div className="col-lg-12 col-md-12">
                <div className="mb-3">
                  <label className="form-label">Resigning Reason</label>
                  <textarea
                    rows={5}
                    type="text"
                    className="form-control"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="">
                  <button
                    type="button"
                    className="btn btn-submit ml-0"
                    onClick={() => {
                      if (!reason) {
                        showWarning("need a reason for disable employee!");
                        return;
                      }
                      deleteEmployeeMethod({
                        id: record._id,
                        reason,
                        setLoading: setLoading4,
                      });
                    }}
                    disabled={loading4}
                  >
                    {loading4 ? <Spin size="small" /> : "Disable"}
                  </button>
                </div>

                <button
                  type="button"
                  className="btn btn-cancel"
                  onClick={() => {
                    setIsModalOpen2(false);
                    setReason("");
                    setRecord("");
                  }}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <BulkUploadModal
        isVisible={isBulkUploadModalOpen}
        handleCancel={() => setIsBulkUploadModalOpen(false)}
        onUploadData={searchEmployees}
      />

      <Modal
        zIndex={1050}
        open={isResign}
        footer={null}
        maskClosable={false}
        closable={false}
        width={600}
      >
        <EmployeeResignModal
          handleCancel={() => {
            setIsResign(false);
            searchEmployees()
          }}
          employeeId={recordId}
          empRecord={empRecord}
        />
      </Modal>
    </div>
  );
};

export default EmployeesGrid;
